import React, { useState } from "react";
import AboutDisplay from "./AboutDisplay";
import DefinitionDisplay from "./DefinitionDisplay";

export default function TabTypeSelector(props) {
    const [selected, setSelected] = useState('about');

    return (
        <div>
            <div className="flex">
                <div className={"mr-3 bg-city-green-medium/30 px-2 py-0.5 hover:bg-city-green-medium/50 cursor-pointer" + (selected === 'about' ? ' underline' : '')} onClick={() => setSelected('about')}>General</div>
                <div className={"mr-3 bg-city-green-medium/30 px-2 py-0.5 hover:bg-city-green-medium/50 cursor-pointer" + (selected === 'defs' ? ' underline' : '')} onClick={() => setSelected('defs')}>Definitions</div>
            </div>
            {selected === 'about' && <AboutDisplay setSelected={setSelected}/>}
            {selected === 'defs' && <DefinitionDisplay />}
        </div>
    )
}